import moment from "../../util/momentTimezone";

export const BESS_PARAMS_ENUM = {
  STATE_OF_CHARGE: "SoC",
  STATE_OF_HEALTH: "SoH",
  CHARGE_TOTAL: "Charge_Total",
  DISCHARGE_TOTAL: "Discharge_Total",
  POWER: "Power",
  CURRENT: "Current",
  TEMPERATURE: "Temp",
  VOLTAGE: "Voltage",
  STATUS_CODE: "Status",
  STATUS_MSG: "Status_Message",
  GY_STATUS: "GY_Status"
};

export const get_BESS_col_name = (cabinet_no, bess_param) => {
  const cabinet = !isNaN(parseInt(cabinet_no)) ? cabinet_no.toString().padStart(2, '0') : cabinet_no;
  return `BESS_Cabinet_${cabinet}_${bess_param}`;
}

export const combine_cabinet_data = (row, nb_cabients) => {
  const newRow = {
    ...row,
    [get_BESS_col_name("ALL", BESS_PARAMS_ENUM.STATE_OF_CHARGE)]: 0,
    [get_BESS_col_name("ALL", BESS_PARAMS_ENUM.STATE_OF_HEALTH)]: 0,
    [get_BESS_col_name("ALL", BESS_PARAMS_ENUM.POWER)]: 0,
    [get_BESS_col_name("ALL", BESS_PARAMS_ENUM.VOLTAGE)]: 0,
    [get_BESS_col_name("ALL", BESS_PARAMS_ENUM.CURRENT)]: 0,
    [get_BESS_col_name("ALL", BESS_PARAMS_ENUM.TEMPERATURE)]: 0,
  };
  for(let i = 1; i <= nb_cabients; i++) {
    // aveage SoC and SoH
    newRow[get_BESS_col_name("ALL", BESS_PARAMS_ENUM.STATE_OF_CHARGE)] += row[get_BESS_col_name(i, BESS_PARAMS_ENUM.STATE_OF_CHARGE)] / nb_cabients;
    newRow[get_BESS_col_name("ALL", BESS_PARAMS_ENUM.STATE_OF_HEALTH)] += row[get_BESS_col_name(i, BESS_PARAMS_ENUM.STATE_OF_HEALTH)] / nb_cabients;
    // sum of power
    newRow[get_BESS_col_name("ALL", BESS_PARAMS_ENUM.POWER)] += row[get_BESS_col_name(i, BESS_PARAMS_ENUM.POWER)];
    // average voltage and current
    newRow[get_BESS_col_name("ALL", BESS_PARAMS_ENUM.VOLTAGE)] += row[get_BESS_col_name(i, BESS_PARAMS_ENUM.VOLTAGE)] / nb_cabients;
    newRow[get_BESS_col_name("ALL", BESS_PARAMS_ENUM.CURRENT)] += row[get_BESS_col_name(i, BESS_PARAMS_ENUM.CURRENT)] / nb_cabients;
    // average cabinet temperature
    newRow[get_BESS_col_name("ALL", BESS_PARAMS_ENUM.TEMPERATURE)] += (row[get_BESS_col_name(i, BESS_PARAMS_ENUM.TEMPERATURE)] || 0) / nb_cabients;
  }
  return newRow;
}

export const map_daily_data = data => {
  const dailyData = {};
  for(let key of Object.keys(data[0])) {
    dailyData[key] = data.map(row => row[key]);
    if(key === 'dateData') {
      dailyData[key] = dailyData[key].map(dateStr => moment(dateStr).format('DD/MM'));
    }
  }
  return dailyData;
}

export const map_monthly_data = data => {
  const monthlyData = {};
  for(let key of Object.keys(data[0])) {
    monthlyData[key] = data.map(row => row[key]);
    if(key === 'dateData') {
      monthlyData[key] = monthlyData[key].map(dateStr => moment(dateStr).format('MM/YYYY'));
    }
  }
  return monthlyData;
}